import React, { useState, useEffect } from "react";
import { BeatLoader } from "react-spinners";
import {
  getAllCourse,
  getCategoryByType,
  getCourseByCategory,
  getVirtualByCategory,
} from "../../api/app";
import Footer from "../../components/layout/Footer";
import { truncate } from "../../utils/trunate";
import { encodeQueryParameter } from "../../utils/url";
import { useSelector } from "react-redux";
import SEO from "../../components/layout/Seo";
import SearchInput from "../../components/layout/SearchInput";
import { MdVideoLibrary } from "react-icons/md";
import SlideShow from "../../components/layout/SlideShow";

const Courses = () => {
  const auth = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState(null);
  const [searchCourse, setSearchCourse] = useState("");
  const [categoryCourse, setCategoryCourse] = useState([]);
  const [selectedCourseCategory, setSelectedCourseCategory] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [loadSelectedCourseCategory, setLoadSelectedCourseCategory] = useState(
    false
  );

  useEffect(() => {
    getAllCourse().then((response) => {
      if (!response.error) {
        setCourses(response.payload);
        setLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    getCategoryByType("course").then((response) => {
      setCategoryCourse(response.payload);
    });
  }, []);

  const handleSelectedCourseCategory = (item) => {
    setLoadSelectedCourseCategory(true);
    setSelectedCategoryId(item._id);
    getCourseByCategory(item._id).then((response) => {
      setSelectedCourseCategory(response.payload);
      setLoadSelectedCourseCategory(false);
    });
  };

  const filteredCourses = courses?.filter(
    (course) =>
      course.name.toLowerCase().includes(searchCourse.toLowerCase()) ||
      course.description.toLowerCase().includes(searchCourse.toLowerCase())
  );

  return (
    <div>
      <SEO title="ZStudy | Courses" description="Lists of Courses" />
      {loading ? (
        <div className="h-screen flex item-center justify-center">
          <div className="loader">
            <BeatLoader color="#003074" size={20} />
          </div>
        </div>
      ) : (
        <div className="container">
          <SearchInput
            searchQuery={searchCourse}
            setSearchQuery={setSearchCourse}
            placeholder="Search courses by name..."
          />
          {searchCourse?.length <= 0 && (
            <div className="mt-10">
              <SlideShow type={"stem"} />
            </div>
          )}
          <div className="md:flex justify-between items-center mb-8">
            <div>
              <div className="text-xl font-semibold">Courses</div>
              <div className="text-sm mt-2 font-medium text-gray-500 leading-6">
                {" "}
                Choose from {courses.length} courses with new additions
                published every months
              </div>
            </div>
          </div>

          {filteredCourses.length === 0 ? (
            <div className="flex flex-col items-center justify-center mt-10">
              <div>
                <MdVideoLibrary className="text-8xl" />
              </div>
              <p className="text-center text-gray-600 text-lg">
                No lesson courses found matching your search.
              </p>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                {/* Right side: Course Detail/Overview (8 columns on large screens) */}
                <div className="lg:col-span-3">
                  <div>
                    <ul className="text-gray-600 mt-3">
                      {categoryCourse?.map((item) => {
                        return (
                          <li key={item._id}>
                            <div
                              className={`text-lg cursor-pointer ${
                                selectedCategoryId === item._id
                                  ? "text-blue-600 font-semibold"
                                  : "text-gray-600"
                              }`}
                              onClick={() => handleSelectedCourseCategory(item)}
                            >
                              {item?.name}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>

                <div className="lg:col-span-8">
                  {selectedCourseCategory.length >= 1 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                      {selectedCourseCategory?.map((item) => (
                        <>
                          {loadSelectedCourseCategory ? (
                            <div className="flex justify-center items-center h-40">
                              <div className="w-8 h-8 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
                            </div>
                          ) : (
                            <a
                              key={item._id}
                              href={`#/course/${item._id}`}
                              className="uk-link-reset"
                            >
                              <div className="card uk-transition-toggle">
                                <div className="card-media h-40 relative">
                                  <div className="card-media-overly absolute inset-0 bg-black bg-opacity-30"></div>
                                  <img
                                    src={item.cover.uri}
                                    alt={item.name}
                                    className="w-full h-full object-cover"
                                  />
                                  <span className="icon-play absolute top-2 right-2"></span>
                                </div>
                                <div className="card-body p-4">
                                  <div className="font-semibold line-clamp-2">
                                    {item.name}
                                  </div>
                                  <div className="flex space-x-2 items-center text-sm pt-3">
                                    <div>{item.category.name}</div>
                                  </div>
                                  <div className="pt-1 flex items-center justify-between">
                                    <div className="text-sm font-medium">
                                      ZStudy
                                    </div>
                                    <div className="text-md font-semibold">
                                      {item.premium ? "Premium" : "Free"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          )}
                        </>
                      ))}
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                      {filteredCourses?.map((item) => (
                        <a
                          key={item._id}
                          href={`#/course/${item._id}`}
                          className="uk-link-reset"
                        >
                          <div className="card uk-transition-toggle">
                            <div className="card-media h-40 relative">
                              <div className="card-media-overly absolute inset-0 bg-black bg-opacity-30"></div>
                              <img
                                src={item.cover.uri}
                                alt={item.name}
                                className="w-full h-full object-cover"
                              />
                              <span className="icon-play absolute top-2 right-2"></span>
                            </div>
                            <div className="card-body p-4">
                              <div className="font-semibold line-clamp-2">
                                {item.name}
                              </div>
                              <div className="flex space-x-2 items-center text-sm pt-3">
                                <div>{item.category.name}</div>
                              </div>
                              <div className="pt-1 flex items-center justify-between">
                                <div className="text-sm font-medium">
                                  ZStudy
                                </div>
                                <div className="text-md font-semibold">
                                  {item.premium ? "Premium" : "Free"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      ))}
                    </div>
                  )}

                  {/* Left side: Course List (4 columns on large screens) */}
                </div>
              </div>
            </>
          )}
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Courses;
